<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtestType" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</h2>
            <div class="c-text">【属性別配信のA/Bテスト】</div>
          </div>
          <div class="c-progress c-progress--abtest-demogra">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">メッセージの作成</li>
              <li class="c-progress-list__item is-current">属性条件の<br />A/B設定</li>
              <!-- <li class="c-progress-list__item">配信条件の<br>設定</li> -->
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <abtest-info :abtest="abtest" />
        </div>
        <div class="l-main-content l-main-content--select-demogra">
          <h3 class="c-title">
            <div class="c-title__text u-fs22">デモグラフィック（属性）</div>
          </h3>
          <div class="p-abtest-edit-select-demogra">
            <div class="p-message-edit p-message-edit--segment">
              <h4 class="c-title c-title--pattern" data-text="A">
                <div class="c-title__text u-fs16">Aパターンの属性データ</div>
              </h4>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--gender">
                    <div class="c-select-label__title">性別</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersA"
                            type="checkbox"
                            name="demogra_gender_a"
                            :value="allValue"
                            @change="genderAAllChanged"
                          />
                          <div class="c-select-label__item">すべて</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersA"
                            type="checkbox"
                            name="demogra_gender_a"
                            :value="demograInfo.topicConditionGenderTypes.Male"
                            @change="genderAChanged"
                          />
                          <div class="c-select-label__item">男性</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersA"
                            type="checkbox"
                            name="demogra_gender_a"
                            :value="demograInfo.topicConditionGenderTypes.Female"
                            @change="genderAChanged"
                          />
                          <div class="c-select-label__item">女性</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--age">
                    <div class="c-select-label__title">年齢</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="allValue"
                            @change="ageAAllChanged"
                          />
                          <div class="c-select-label__item">すべて</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A15_20"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">15歳-20歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A20_25"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">20歳-25歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A25_30"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">25歳-30歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A30_35"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">30歳-35歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A35_40"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">35歳-40歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A40_45"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">40歳-45歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A45_50"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">45歳-50歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesA"
                            type="checkbox"
                            name="demogra_age_a"
                            :value="demograInfo.topicConditionAgeTypes.A50_UL"
                            @change="ageAChanged"
                          />
                          <div class="c-select-label__item">50歳以上</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <select-region-list-item
                    ref="refSelectRegionListItemA"
                    :all-value="allValue"
                    :initial-regions="regionsA"
                    :initial-prefectures="prefecturesA"
                    :on-change="onSelectRegionListItemChangeA"
                    :prefecture-types="demograInfo.topicConditionPrefectureTypes"
                    :region-types="demograInfo.topicConditionRegionTypes"
                  />
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--company">
                    <div class="c-select-label__title">企業</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="companyA"
                            type="checkbox"
                            name="demogra_company"
                            :value="demograInfo.topicConditionCompanyTypes.Yes"
                            @change="companyAChanged"
                          />
                          <div class="c-select-label__item">企業ユーザー</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="c-title c-title--wrap c-title--audience">
                                <div class="c-title__text u-fs24">オーディエンス（興味・関心）</div>
                                <div class="c-text u-fs--s">
                                    説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります
                                </div>
                            </div>
                            <div class="p-message-edit-list">
                                <div class="p-message-edit-list__item">
                                    <select-text
                                    :value="interestA"
                                    @select="onInterestSelectA"
                                    ref="interestA"
                                    :elements="demograInfo.userInterestRankings"
                                    title="興味トップ"
                                    place-holder="ユーザーが興味・関心のあるセグメントを選択"
                                    input-name="interest_category_a">
                                    </select-text>
                                </div>
                                <div class="p-message-edit-list__item">
                                    <select-text
                                    :value="keywordA"
                                    @select="onKeywordSelectA"
                                    ref="keywordA"
                                    :elements="demograInfo.userKeywordRankings"
                                    title="キーワードトップ"
                                    place-holder="キーワードを選択してください"
                                    input-name="interest_keyword_a">
                                    </select-text>
                                </div>
                            </div> -->
            </div>
            <div class="p-message-edit p-message-edit--segment">
              <h4 class="c-title c-title--pattern" data-text="B">
                <div class="c-title__text u-fs16">Bパターンの属性データ</div>
              </h4>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--gender">
                    <div class="c-select-label__title">性別</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersB"
                            type="checkbox"
                            name="demogra_gender_b"
                            :value="allValue"
                            @change="genderBAllChanged"
                          />
                          <div class="c-select-label__item">すべて</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersB"
                            type="checkbox"
                            name="demogra_gender_b"
                            :value="demograInfo.topicConditionGenderTypes.Male"
                            @change="genderBChanged"
                          />
                          <div class="c-select-label__item">男性</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="gendersB"
                            type="checkbox"
                            name="demogra_gender_b"
                            :value="demograInfo.topicConditionGenderTypes.Female"
                            @change="genderBChanged"
                          />
                          <div class="c-select-label__item">女性</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--age">
                    <div class="c-select-label__title">年齢</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="allValue"
                            @change="ageBAllChanged"
                          />
                          <div class="c-select-label__item">すべて</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A15_20"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">15歳-20歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A20_25"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">20歳-25歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A25_30"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">25歳-30歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A30_35"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">30歳-35歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A35_40"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">35歳-40歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A40_45"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">40歳-45歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A45_50"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">45歳-50歳</div>
                        </label>
                      </li>
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="agesB"
                            type="checkbox"
                            name="demogra_age_b"
                            :value="demograInfo.topicConditionAgeTypes.A50_UL"
                            @change="ageBChanged"
                          />
                          <div class="c-select-label__item">50歳以上</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <select-region-list-item
                    ref="refSelectRegionListItemB"
                    :all-value="allValue"
                    :initial-regions="regionsB"
                    :initial-prefectures="prefecturesB"
                    :on-change="onSelectRegionListItemChangeB"
                    :prefecture-types="demograInfo.topicConditionPrefectureTypes"
                    :region-types="demograInfo.topicConditionRegionTypes"
                  />
                </div>
              </div>
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-select-label c-select-label--company">
                    <div class="c-select-label__title">企業</div>
                    <ul class="c-select-label-list">
                      <li class="c-select-label-list__item">
                        <label class="c-select-label__label">
                          <input
                            v-model="companyB"
                            type="checkbox"
                            name="demogra_company"
                            :value="demograInfo.topicConditionCompanyTypes.Yes"
                            @change="companyBChanged"
                          />
                          <div class="c-select-label__item">企業ユーザー</div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="c-title c-title--wrap c-title--audience ">
                                <div class="c-title__text u-fs24">オーディエンス（興味・関心）</div>
                                <div class="c-text u-fs--s">
                                    説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります
                                </div>
                            </div>
                            <div class="p-message-edit-list">
                                <div class="p-message-edit-list__item">
                                    <select-text
                                    :value="interestB"
                                    @select="onInterestSelectB"
                                    ref="interestB"
                                    :elements="demograInfo.userInterestRankings"
                                    title="興味トップ"
                                    place-holder="ユーザーが興味・関心のあるセグメントを選択"
                                    input-name="interest_category_b">
                                    </select-text>
                                </div>
                                <div class="p-message-edit-list__item">
                                    <select-text
                                    :value="keywordB"
                                    @select="onKeywordSelectB"
                                    ref="keywordB"
                                    :elements="demograInfo.userKeywordRankings"
                                    title="キーワードトップ"
                                    place-holder="キーワードを選択してください"
                                    input-name="interest_keyword_b">
                                    </select-text>
                                </div>
                            </div> -->
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn }"
            :disabled="isLoadingNextBtn"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">確認画面へ</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    abtestType: String,
    abtestTypeValues: Object,
    linkData: Object,
    abtest: Object,
    demograInfo: Object,
  },
  data () {
    return {
      gendersA: [],
      gendersB: [],
      agesA: [],
      agesB: [],
      regionsA: [],
      regionsB: [],
      prefecturesA: [],
      prefecturesB: [],
      interestA: null,
      interestB: null,
      keywordA: null,
      keywordB: null,
      companyA: [],
      companyB: [],
      allValue: '9999',
      errorMessage: '',
      isError: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
    }
  },
  mounted: function() {
    import('../../funcs/pages/abtest-message-add').then(module => {
      module.AbtestMessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    // console.log("mounted",this.abtest);
    // console.log("details",this.abtest.abtest_messages[0].message.topic_message_condition.topic_condition.topic_condition_details);

    if(
      this.abtest.abtest_messages[0].message.topic_message_condition &&
      this.abtest.abtest_messages[0].message.topic_message_condition.topic_condition &&
      this.abtest.abtest_messages[0].message.topic_message_condition.topic_condition.topic_condition_details
    ) {
      let topicConditionDetails = this.abtest.abtest_messages[0].message.topic_message_condition.topic_condition.topic_condition_details;
      let values = this.getValueArray(topicConditionDetails);
      this.gendersA = values.genders;
      this.agesA = values.ages;
      this.regionsA = values.regions;
      this.interestA = values.interest;
      this.keywordA = values.keyword;
      this.companyA = values.company;
      this.genderAChanged();
      this.ageAChanged();
      this.companyAChanged();
      this.$refs.refSelectRegionListItemA.updateRegions(this.regionsA);
      //
      // @TODO: 保存済みの都道府県IDがバックエンドから返却されるようになったら、を設定する処理を追加する事
      //
      // this.$refs.refSelectRegionListItemA.updatePrefectures(this.prefecturesA);

      topicConditionDetails = this.abtest.abtest_messages[1].message.topic_message_condition.topic_condition.topic_condition_details;
      values = this.getValueArray(topicConditionDetails);
      this.gendersB = values.genders;
      this.agesB = values.ages;
      this.regionsB = values.regions;
      this.interestB = values.interest;
      this.keywordB = values.keyword;
      this.companyB = values.company;
      this.genderBChanged();
      this.ageBChanged();
      this.companyBChanged();
      this.$refs.refSelectRegionListItemB.updateRegions(this.regionsB);
      //
      // @TODO: 保存済みの都道府県IDがバックエンドから返却されるようになったら、を設定する処理を追加する事
      //
      // this.$refs.refSelectRegionListItemB.updatePrefectures(this.prefecturesB);
    }
  },
  methods: {
    getValueArray: function(topicConditionDetails)
    {
      var values = {
        genders: [],
        ages: [],
        regions: [],
        interest: '',
        keyword: '',
        company: []
      };
      topicConditionDetails.forEach(topicConditionDetail => {
        if(topicConditionDetail.data_type == 'sex'){
          if(topicConditionDetail.condition_1 == '男性'){
            values.genders.push(this.demograInfo.topicConditionGenderTypes.Male);
          } else if(topicConditionDetail.condition_1 == '女性'){
            values.genders.push(this.demograInfo.topicConditionGenderTypes.Female);
          }
          // this.genderAChanged();
        } else if(topicConditionDetail.data_type == 'age'){
          if((topicConditionDetail.condition_1 == '15') && (topicConditionDetail.condition_2 == '20')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A15_20);
          } else if((topicConditionDetail.condition_1 == '20') && (topicConditionDetail.condition_2 == '25')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A20_25);
          } else if((topicConditionDetail.condition_1 == '25') && (topicConditionDetail.condition_2 == '30')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A25_30);
          } else if((topicConditionDetail.condition_1 == '30') && (topicConditionDetail.condition_2 == '35')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A30_35);
          } else if((topicConditionDetail.condition_1 == '35') && (topicConditionDetail.condition_2 == '40')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A35_40);
          } else if((topicConditionDetail.condition_1 == '40') && (topicConditionDetail.condition_2 == '45')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A40_45);
          } else if((topicConditionDetail.condition_1 == '45') && (topicConditionDetail.condition_2 == '50')){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A45_50);
          } else if(topicConditionDetail.condition_1 == '50'){
            values.ages.push(this.demograInfo.topicConditionAgeTypes.A50_UL);
          }
          // this.ageAChanged();
        } else if(topicConditionDetail.data_type == 'pref'){
          if(topicConditionDetail.condition_1 == '北海道'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Hokkaido);
          } else if(topicConditionDetail.condition_1 == '東北'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Tohoku);
          } else if(topicConditionDetail.condition_1 == '関東'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Kanto);
          } else if(topicConditionDetail.condition_1 == '中部'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Chubu);
          } else if(topicConditionDetail.condition_1 == '近畿'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Kinki);
          } else if(topicConditionDetail.condition_1 == '中国'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Chugoku);
          } else if(topicConditionDetail.condition_1 == '四国'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Shikoku);
          } else if(topicConditionDetail.condition_1 == '九州'){
            values.regions.push(this.demograInfo.topicConditionRegionTypes.Kyushu);
          }
          // this.regionAChanged();

          //
          // @TODO: 保存済みの都道府県IDがバックエンドから返却されるようになったら、を設定する処理を追加する事
          //

        } else if(topicConditionDetail.data_type == 'interest'){
          values.interest = topicConditionDetail.condition_1;
        } else if(topicConditionDetail.data_type == 'keyword'){
          values.keyword = topicConditionDetail.condition_1;
        } else if(topicConditionDetail.data_type == 'company'){
          values.company = [topicConditionDetail.condition_1];
        }
      });
      return values;
    },
    showCalendar: function(name) {
      $("*[name="+name+"]").click();
    },
    onSaveClick: function() {
      this.isLoadingSaveBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.listUrl,false);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
      }
    },
    onQuitClick: function() {
      location.href = this.linkData.listUrl;
    },
    onNextClick: function(event) {
      event.preventDefault();
      this.isLoadingNextBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.confirmUrl,true);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
      }
    },
    companyAChanged: function() {
      if (this.companyA.length > 1) {
        this.companyA.splice(0, 1);
      }
    },
    companyBChanged: function() {
      if (this.companyB.length > 1) {
        this.companyB.splice(0, 1);
      }
    },
    saveAbtest: function(completeUrl,hasArgument) {
      //*
      let params = new FormData();
      this.appendForm(params,'abtest_id',this.abtest.abtest_id);
      this.appendForm(params,'genders_a',this.gendersA);
      this.appendForm(params,'ages_a',this.agesA);
      this.appendForm(params,'regions_a',this.regionsA);
      this.appendForm(params,'prefectures_a',this.prefecturesA);
      this.appendForm(params,'interest_a',this.interestA);
      this.appendForm(params,'keyword_a',this.keywordA);
      this.appendForm(params,'genders_b',this.gendersB);
      this.appendForm(params,'ages_b',this.agesB);
      this.appendForm(params,'regions_b',this.regionsB);
      this.appendForm(params,'prefectures_b',this.prefecturesB);
      this.appendForm(params,'interest_b',this.interestB);
      this.appendForm(params,'keyword_b',this.keywordB);
      this.appendForm(params,'company_a', this.companyA);
      this.appendForm(params,'company_b', this.companyB);

      axios.post('/api/abtest/save-demogra',params)
        .then(res => {
          if(this.handleResponse(res)){
            let url = completeUrl;
            if(hasArgument){
              url += '?abtest_id=' + res.data.abtest_id;
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        });
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    validate: function() {
      let isValid = true;
      let errors = {};

      // すべて任意入力なのでバリデーションは無し
      /*
            if(this.gendersA.length == 0){
                errors['demogra_gender_a'] = '性別を入力してください';
            }
            */

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },

    setButtonLoading: function(name) {
      this.currentButton = $('button[name="' + name + '"]');
      this.currentButton.addClass('is-loading').prop('disabled', 'disabled');
    },


    genderAAllChanged: function() {
      if(this.gendersA.includes(this.allValue)){
        this.gendersA = [
          this.allValue,
          this.demograInfo.topicConditionGenderTypes.Male,
          this.demograInfo.topicConditionGenderTypes.Female,
        ];
      } else {
        this.gendersA = [];
      }
    },
    genderAChanged: function() {
      let diff = [
        this.demograInfo.topicConditionGenderTypes.Male,
        this.demograInfo.topicConditionGenderTypes.Female
      ].filter(value => !this.gendersA.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.gendersA.includes(this.allValue)){
          this.gendersA.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.gendersA.indexOf(this.allValue)
        if(index >= 0){
          this.gendersA.splice(index,1);
        }
      }
    },
    ageAAllChanged: function() {
      if(this.agesA.includes(this.allValue)){
        this.agesA = [
          this.allValue,
          this.demograInfo.topicConditionAgeTypes.A15_20,
          this.demograInfo.topicConditionAgeTypes.A20_25,
          this.demograInfo.topicConditionAgeTypes.A25_30,
          this.demograInfo.topicConditionAgeTypes.A30_35,
          this.demograInfo.topicConditionAgeTypes.A35_40,
          this.demograInfo.topicConditionAgeTypes.A40_45,
          this.demograInfo.topicConditionAgeTypes.A45_50,
          this.demograInfo.topicConditionAgeTypes.A50_UL,
        ];
      } else {
        this.agesA = [];
      }
    },
    ageAChanged: function() {
      let diff = [
        this.demograInfo.topicConditionAgeTypes.A15_20,
        this.demograInfo.topicConditionAgeTypes.A20_25,
        this.demograInfo.topicConditionAgeTypes.A25_30,
        this.demograInfo.topicConditionAgeTypes.A30_35,
        this.demograInfo.topicConditionAgeTypes.A35_40,
        this.demograInfo.topicConditionAgeTypes.A40_45,
        this.demograInfo.topicConditionAgeTypes.A45_50,
        this.demograInfo.topicConditionAgeTypes.A50_UL
      ].filter(value => !this.agesA.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.agesA.includes(this.allValue)){
          this.agesA.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.agesA.indexOf(this.allValue)
        if(index >= 0){
          this.agesA.splice(index,1);
        }
      }
    },
    genderBAllChanged: function() {
      if(this.gendersB.includes(this.allValue)){
        this.gendersB = [
          this.allValue,
          this.demograInfo.topicConditionGenderTypes.Male,
          this.demograInfo.topicConditionGenderTypes.Female,
        ];
      } else {
        this.gendersB = [];
      }
    },
    genderBChanged: function() {
      let diff = [
        this.demograInfo.topicConditionGenderTypes.Male,
        this.demograInfo.topicConditionGenderTypes.Female
      ].filter(value => !this.gendersB.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.gendersB.includes(this.allValue)){
          this.gendersB.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.gendersB.indexOf(this.allValue)
        if(index >= 0){
          this.gendersB.splice(index,1);
        }
      }
    },
    ageBAllChanged: function() {
      if(this.agesB.includes(this.allValue)){
        this.agesB = [
          this.allValue,
          this.demograInfo.topicConditionAgeTypes.A15_20,
          this.demograInfo.topicConditionAgeTypes.A20_25,
          this.demograInfo.topicConditionAgeTypes.A25_30,
          this.demograInfo.topicConditionAgeTypes.A30_35,
          this.demograInfo.topicConditionAgeTypes.A35_40,
          this.demograInfo.topicConditionAgeTypes.A40_45,
          this.demograInfo.topicConditionAgeTypes.A45_50,
          this.demograInfo.topicConditionAgeTypes.A50_UL,
        ];
      } else {
        this.agesB = [];
      }
    },
    ageBChanged: function() {
      let diff = [
        this.demograInfo.topicConditionAgeTypes.A15_20,
        this.demograInfo.topicConditionAgeTypes.A20_25,
        this.demograInfo.topicConditionAgeTypes.A25_30,
        this.demograInfo.topicConditionAgeTypes.A30_35,
        this.demograInfo.topicConditionAgeTypes.A35_40,
        this.demograInfo.topicConditionAgeTypes.A40_45,
        this.demograInfo.topicConditionAgeTypes.A45_50,
        this.demograInfo.topicConditionAgeTypes.A50_UL
      ].filter(value => !this.agesB.includes(value));
      if(diff.length == 0){
        // すべてがチェックされていたら「すべて」にもチェックする
        if(!this.agesB.includes(this.allValue)){
          this.agesB.push(this.allValue);
        }
      } else {
        // すべてがチェックされているわけではない場合は「すべて」を解除する
        let index = this.agesB.indexOf(this.allValue)
        if(index >= 0){
          this.agesB.splice(index,1);
        }
      }
    },
    onInterestSelectA: function(selected) {
      this.interestA = selected;
    },
    onKeywordSelectA: function(selected) {
      this.keywordA = selected;
    },
    onInterestSelectB: function(selected) {
      this.interestB = selected;
    },
    onKeywordSelectB: function(selected) {
      this.keywordB = selected;
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onSelectRegionListItemChangeA: function(regions, prefectures) {
      this.regionsA = regions;
      this.prefecturesA =prefectures;
    },
    onSelectRegionListItemChangeB: function(regions, prefectures) {
      this.regionsB = regions;
      this.prefecturesB =prefectures;
    },
  }
}
</script>
